import { Container } from "@material-ui/core";

export function AfriqContainer(props: { children: React.ReactNode }) {
    return (
        <>
            <div style={{ display: "flex", justifyContent: "center" }}>
                <Container>
                    <div>{props.children}</div>
                </Container>
            </div>
        </>
    );
}


